import { mutatorAction } from 'satcheljs';
import getWin32StyleStore from '../store/win32StyleStore';

/**
 * Writes the given value as both the committed (last-saved) and live (preview) Win32 style value,
 * leaving the store in a clean (non-dirty) state. The intent lives in the caller: commit a saved
 * value, discard an unsaved preview (by writing the committed value), or hydrate the boot value.
 */
const saveWin32StyleMutator: (isEnabled: boolean) => void = mutatorAction(
    'saveWin32Style',
    (isEnabled: boolean): void => {
        const store = getWin32StyleStore();
        store.isEnabled = isEnabled;
        store.isEnabledPreview = isEnabled;
    }
);

export default saveWin32StyleMutator;
